(function () {
	const initCollapsibleContent = () => {
		// Any accordion group can opt in with data-collapsible-mode="one-open" - the
		// collapsible-content section and the PDP details column both use this one wiring.
		const groups = document.querySelectorAll('[data-collapsible-mode="one-open"]');

		groups.forEach((group) => {
			if (group.dataset.accordionBound === "true") {
				return;
			}
			group.dataset.accordionBound = "true";

			const items = group.querySelectorAll("details.accordion");

			items.forEach((details) => {
				details.addEventListener("toggle", () => {
					if (!details.open) {
						return;
					}

					items.forEach((other) => {
						if (other === details || !other.open) {
							return;
						}

						// Route the sibling close through the accordion's slide
						// animation when it is available, so the outgoing panel
						// collapses rather than disappearing instantly.
						if (typeof window.accordionSlide === "function") {
							window.accordionSlide(other, false);
						} else {
							other.open = false;
						}
					});
				});
			});
		});
	};

	const initCollapsibleExpand = () => {
		const $triggers = $(".collapsible-content__expand-link");

		if (!$triggers.length) {
			return;
		}

		$triggers.unbind("click").on("click", function () {
			const $trigger = $(this);
			const $target = $trigger
				.closest(".collapsible-content__item")
				.find(".truncated, .expanded");

			if (!$target.length) {
				return;
			}

			const expand = $target.hasClass("truncated");

			$target.toggleClass("truncated", !expand).toggleClass("expanded", expand);
			$trigger.attr("aria-expanded", expand);
			$trigger.text(expand ? $trigger.data("collapse-label") : $trigger.data("expand-label"));
		});
	};

	const startCollapsibleSlideshow = (images) => {
		if(images.length > 1) {
			let speed = Number(images.closest('.collapsible-content__gallery').data("speed")) * 1000;
			var currentImageIndex = 0;
			let fadeSpeed = 1000; // Time for the crossfade effect (adjust as needed)
			
			images.eq(currentImageIndex).fadeIn(fadeSpeed);

			// Start the slideshow
			var interval = setInterval(function () {
					let nextImageIndex = (currentImageIndex + 1) % images.length;

					// Crossfade: one fades in while the other fades out
					images.eq(currentImageIndex).fadeOut(fadeSpeed);
					images.eq(nextImageIndex).fadeIn(fadeSpeed);

					currentImageIndex = nextImageIndex;
			}, speed);  // Change image every {speed} seconds (adjust as needed)
		}
	}

	const initGallery = () => {
		if($('.collapsible-content').length > 0) {
			$('.collapsible-content').each(function(index, item) {
				var images = $(this).find(".collapsible-content__gallery--image-wrapper");

				if (item.querySelectorAll(".observe-me").length > 0) {
					function createObserver() {
							function handleIntersect(entries, observer) {
									entries.forEach(entry => {
											if (entry.isIntersecting) {
													let css_classlist = entry.target.classList;
													css_classlist.add("is-inview");

													observer.unobserve(entry.target);

													setTimeout(() => {
															css_classlist.remove("is-inview");
															css_classlist.remove("observe-me");

															startCollapsibleSlideshow(images);
													}, 600); // Duration matches the animation duration in SCSS
											}
									});
							}

							let options = {
									root: null,
									rootMargin: "0px",
									threshold: 0.1
							};

							let observer = new IntersectionObserver(handleIntersect, options);
							let targets = item.querySelectorAll(".observe-me");
							targets.forEach((target, index) => {
									observer.observe(target);
							});
					}

					createObserver();
			} else {
					// If there are no elements to observe, start the gallery slideshow immediately
					startCollapsibleSlideshow(images);
			}
			});
		}
	};

	initCollapsibleContent();
	initCollapsibleExpand();
	initGallery();

	document.addEventListener("DOMContentLoaded", function () {
		initCollapsibleContent();
		initCollapsibleExpand();
		initGallery();
		document.addEventListener("shopify:section:load", function () {
			initCollapsibleContent();
			initCollapsibleExpand();
			initGallery();
		});
	});
})();
